var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscription-detail"},[_c('SubscriptionTable',{attrs:{"headers":_vm.headers,"data":_vm.sanitizedItems,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }